// extracted by mini-css-extract-plugin
export default {"volume":"VolumeChange_volume__fCIsm"};